module.exports = __webpack_public_path__ + "img/MotelOne_Wien-Staatsoper_MotelOne_3.jpg";